import { useMemo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { getAllCampaigns } from 'features/views/dashboard/campaigns/selectors';

import CampaignTableRow from './CampaignTableRow';

export const CampaignsTable = () => {
	const allCampaigns = useSelector(getAllCampaigns);

	const noResults = useMemo(
		() => <Typography variant="caption">{getMessage('dashboard:campaigns.noCampaigns')}</Typography>,
		[],
	);

	return isNilOrEmpty(allCampaigns) ? (
		noResults
	) : (
		<ComponentLoader fetchStorePath={fetch.constants.urls.campaignsSummary} forceInlineError>
			<Table
				size="small"
				sx={{
					border: 'none !important',
					'& .MuiTableCell-root': {
						px: 0,
						borderBottom: 'unset',
						borderTop: (theme) => `1px solid ${theme.palette.divider}`,
					},
				}}
			>
				<TableHead>
					<TableRow
						sx={{
							'& .MuiTableCell-root': {
								backgroundColor: 'unset',
								fontSize: 14,
								color: 'grey.500',
								fontWeight: 400,
								borderTop: 'unset',
							},
						}}
					>
						<TableCell>{getMessage('dashboard:campaigns.campaignName')}</TableCell>
						<TableCell align="right">{getMessage('dashboard:campaigns.daysLeft')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{allCampaigns.map((campaign) => (
						<CampaignTableRow campaign={campaign} key={campaign?.id} />
					))}
				</TableBody>
			</Table>
		</ComponentLoader>
	);
};

export default CampaignsTable;
